module.exports = __webpack_public_path__ + "static/media/Help_icon.feb06254.png";